export default __webpack_public_path__ + "static/testimonial-bg-image-ab32daafea8d8d3a58368a77fd48b7a6.svg";